var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.options && _vm.options.length > 0
    ? _c("suc-select-component", {
        attrs: {
          title: _vm.$t("components.fields.establishment.title"),
          options: _vm.options,
          label: "establishmentDescr",
          form: _vm.form,
          name: _vm.name,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "no-options",
              fn: function () {
                return [_vm._v(_vm._s(_vm.$t("components.fields.no_options")))]
              },
              proxy: true,
            },
          ],
          null,
          false,
          4289606014
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }